import React from 'react';
import PropTypes from 'prop-types';

import {
  getResourcePath,
  useSoyuzClientConfig,
  useSoyuzLocales
} from '@spotahome/soyuz/client';

import { Footer as FooterComponent } from '@spotahome/ui-library';

import { useLocaleChange } from '../hooks/useLocaleChange';

function handleHelpClick(e) {
  e.preventDefault();
  if (typeof zE !== 'undefined') {
    zE.activate({ hideOnClose: true });
  }
}

const Footer = ({ theme }) => {
  const clientConfig = useSoyuzClientConfig();
  const handleOnLocaleChange = useLocaleChange();
  const { current } = useSoyuzLocales();

  return (
    <FooterComponent
      theme={theme}
      localeToggle={{ chinese: clientConfig.featureToggle.chinese }}
      help={{
        onClick: handleHelpClick
      }}
      locales={{ current, onChange: handleOnLocaleChange }}
      apps={{
        android: {
          link: 'https://spotahome.app.link/android_footer_home',
          eventCategory: 'app-promotion',
          eventAction: 'footer-icon-android',
          eventLabel: 'open'
        },
        ios: {
          link: 'https://spotahome.app.link/ios_footer_home',
          eventCategory: 'app-promotion',
          eventAction: 'footer-icon-ios',
          eventLabel: 'open'
        }
      }}
      icons={{
        prs: {
          icon: getResourcePath('/images/footer_image/prs.svg')
        },
        cmp: {
          icon: getResourcePath('/images/footer_image/cmp.png')
        }
      }}
    />
  );
};

Footer.propTypes = {
  theme: PropTypes.string
};

Footer.defaultProps = {
  theme: 'blue'
};

export default Footer;
